import React from 'react';
import Modal from 'components/Modal';
import { Step } from 'components/SteppedModal';
import { useSocialShareModal } from 'containers/SocialShareModal/SocialShareModalContext';
import useDisclosureStepHandler from 'containers/TikTokPostModal/steps/useDisclosureStepHandler';
import { TikTokSocialShareStep } from '../../types';
import TikTokDisclosureStep, {
  TikTokDisclosureStepProps,
} from './TikTokDisclosureStep';

export type UseTikTokDisclosureStepConfig = Omit<
  TikTokDisclosureStepProps,
  'showDisabledText' | 'onBackClick'
>;

export default function useTikTokDisclosureStep({
  isDisclosureVisible,
  brandContent,
  brandOrganic,
  onBrandContentChange,
  onBrandOrganicChange,
  onVisibilityChange,
  resetComposerValues,
}: UseTikTokDisclosureStepConfig): Step<TikTokSocialShareStep> {
  const { goToStep } = useSocialShareModal();

  const {
    isUntouched,
    localBrandContent,
    localBrandOrganic,
    onSetLocalBrandContent,
    onSetLocalBrandOrganic,
    onToggleDisclosureVisibility,
    onBackClick,
    onSaveChanges,
  } = useDisclosureStepHandler({
    isDisclosureVisible,
    brandContent,
    brandOrganic,
    onVisibilityChange,
    onBrandContentChange,
    onBrandOrganicChange,
    onBackClick: () => goToStep('composer'),
  });

  return {
    id: 'disclosure',
    component: (
      <TikTokDisclosureStep
        {...{
          isDisclosureVisible,
          onBackClick,
          resetComposerValues,
        }}
        brandContent={localBrandContent ?? brandContent}
        brandOrganic={localBrandOrganic ?? brandOrganic}
        showDisabledText={isDisclosureVisible && isUntouched}
        onBrandContentChange={onSetLocalBrandContent}
        onBrandOrganicChange={onSetLocalBrandOrganic}
        onVisibilityChange={onToggleDisclosureVisibility}
      />
    ),
    fluidFooterButtons: true,
    renderFooterButtons: () => [
      <Modal.FooterButton
        theme="submit"
        disabled={isUntouched}
        onClick={onSaveChanges}
      >
        Save changes
      </Modal.FooterButton>,
    ],
  };
}
